<div class="carousel-cards">
  <button
    type="button"
    class="nav-button d-flex ai-center jc-center cursor-pointer"
    [class.is-disabled]="isPrevDisabled()"
    [disabled]="isPrevDisabled()"
    (click)="prevPage()"
    aria-label="previous"
  >
    <i class="pi pi-chevron-left"></i>
  </button>

  <p-carousel
    #carouselCards
    class="carousel-cards__track"
    [class.is-faded]="fadeEnd && !isNextDisabled()"
    [value]="items"
    [numVisible]="numVisible"
    [numScroll]="1"
    [responsiveOptions]="responsiveOptions"
    [circular]="false"
    [showNavigators]="false"
    [showIndicators]="false"
    styleClass="cards-carousel"
  >
    <ng-template let-item pTemplate="item">
      <ng-container
        *ngTemplateOutlet="itemTemplate || defaultCard; context: { $implicit: item }"
      ></ng-container>
    </ng-template>
  </p-carousel>

  <button
    type="button"
    class="nav-button d-flex ai-center jc-center cursor-pointer"
    [class.is-disabled]="isNextDisabled()"
    [disabled]="isNextDisabled()"
    (click)="nextPage()"
    aria-label="next"
  >
    <i class="pi pi-chevron-right"></i>
  </button>
</div>

<ng-template #defaultCard let-item>
  <button type="button" class="carousel-card" (click)="selectItem(item)">
    <div class="carousel-card__image">
      <img [src]="item.image" [alt]="item.name" />
    </div>
    <span class="carousel-card__name d-flex ai-center jc-center">
      <span class="carousel-card__name-text font-semiBold fts-14">{{ item.name }}</span>
    </span>
  </button>
</ng-template>
